class QuizFormContainer extends HTMLElement {
  constructor () {
    super();

    this.inquerySelect = this.querySelector('.js-inquery-selection')
  }

  connectedCallback () {
    this.inquerySelect.addEventListener('input', this.handleSelectionChange.bind(this))
  }

  disconnectedCallback () {
    this.inquerySelect.removeEventListener('input', this.handleSelectionChange.bind(this))
  }

  handleSelectionChange (event) {
    const formIndex = event.target.value

    this.querySelectorAll('.js-quiz-form').forEach(form => {
      if (form.dataset.formIndex === formIndex) {
        form.classList.add('show')
        setTimeout(() => {
          form.classList.add('active')
        })
      } else {
        form.classList.remove('active')

        setTimeout(() => {
          form.classList.remove('show')
        })
      }
    })
  }
}

customElements.define('lg-quiz-container', QuizFormContainer)